import React from "react";
import Layout from "../layout/Layout";
import Banner from "../components/hiring/Banner";
import IndustryLeaders from "../components/industry-leaders/industry-leaders";
import FeaturesList from "../components/hiring/FeaturesList";
import Benefits from "../components/hiring/Benefits";
import Cta from "../components/hiring/Cta";
import Testimonials from "../components/hiring/Testimonials";

const Hiring = () => {
  return (
    <Layout>
      <Banner />
      <IndustryLeaders />
      <FeaturesList />
      <Benefits />
      <Cta />
      <Testimonials />
    </Layout>
  );
};

export default Hiring;

